document.addEventListener('DOMContentLoaded', function () {
	let selectorString = '';
	if (document.querySelector('body.page-template-template-investors')) {
		selectorString =
			'.section-details > .finance-details, .section-details > .wp-block-group.is-layout-constrained';
	} else if (document.querySelector('body.page-template-template-people-index')) {
		selectorString = '.team-section > .section-details';
	} else {
		return;
	}
	const sections = document.querySelectorAll(selectorString);
	const menuLinks = document.querySelectorAll('.section-menu .list-items a');

	function checkSectionInView() {
		let index = sections.length - 1;

		sections.forEach((section, idx) => {
			if (section && window.scrollY + 50 < sections[idx].offsetTop) {
				index -= 1;
			}
		});

		if (index >= 0) {
			menuLinks.forEach(link => link.classList.remove('active'));
			menuLinks[index].classList.add('active');
		}
	}

	window.addEventListener('scroll', checkSectionInView);
	window.addEventListener('load', checkSectionInView);

	window.addEventListener('scroll', () => {
		const sectionMenu = document.querySelector('.section-menu');
		const scrollHeight = window.scrollY;
		if (scrollHeight >= 240 && sectionMenu) {
			sectionMenu.classList.add('active');
		} else {
			sectionMenu.classList.remove('active');
		}
	});
});
